<template>
  <div class="fivth-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <h2 class="category">{{ item.sub_category.name }}</h2>
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
      </div>
      <div class="about">
        <h2 class="category-about category">{{ item.sub_category.name }}</h2>
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
        <span class="decor-line-bottom"></span>
      </div>
    </router-link>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FivthBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.fivth-Bar {
  margin: 2rem 0;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-auto-rows: minmax(0, 18.5%);
  grid-template-areas:
    "card-1 card-1 card-1 card-1 card-1 card-2 card-2 card-2"
    "card-1 card-1 card-1 card-1 card-1 card-3 card-3 card-3"
    "card-1 card-1 card-1 card-1 card-1 card-4 card-4 card-4"
    "card-1 card-1 card-1 card-1 card-1 card-5 card-5 card-5"
    "card-1 card-1 card-1 card-1 card-1 card-6 card-6 card-6"
    "card-1 card-1 card-1 card-1 card-1 card-7 card-7 card-7";
  grid-row-gap: 1.5em;
  grid-column-gap: 0;
  position: relative;
  width: 90%;
  .card {
    position: relative;
    display: flex;
    .image-block {
      position: relative;
      max-width: 18.5%;
      width: 100%;
      .image {
        position: relative;
        width: 100%;
        padding-bottom: 67.295%;
        border-radius: 0.25em;
      }
      .category {
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--secondary-font-color);
        padding: 0.1rem 0.25rem;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2.5em;
        line-height: 1.4;
        z-index: 1;
        display: none;
        text-transform: capitalize;
        color: var(--category-color);
      }
    }
    .about {
      position: relative;
      padding-left: 2%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 2.5em;
      .category-about {
        position: relative;
        opacity: 0.6;
        color: var(--category-color);
      }
      .text {
        --snup: 2;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
        position: relative;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
        color: var(--primary-font-color);
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 300;
        // font-size: 2.5em;
        line-height: 1;
        color: var(--date-color);
        opacity: 0.6;
        padding: 0 0 3% 0;
      }
      .decor-line-bottom {
        position: absolute;
        width: 100%;
        height: 1px;
        bottom: -1%;
        background: var(--primary-font-color);
        margin-top: auto;
      }
    }
    &:nth-child(1) {
      flex-direction: column;
      left: -9%;
      width: 105%;
      .image-block {
        max-width: inherit;
        .image {
          height: 39vw;
        }
        .category {
          display: inline-block;
          font-size: 1em;
        }
      }
      .about {
        text-align: center;
        padding: 0.3% 20% 0 10%;
        .text {
          line-height: 1.4;
          padding: 0 0 1% 0;
          margin-top: 0.5rem;
          --snup: 3;
        }
        .category-about {
          display: none;
        }
        .decor-line-bottom {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .fivth-Bar {
    width: 90%;
    .card {
      .image-block {
        .category {
          font-size: 1.5em;
        }
      }
      .about {
        font-size: 1.3em;
        .time {
          font-size: 1.1em;
        }
      }
      &:nth-child(1) {
        .about {
          .text {
            font-size: 1.5em;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .fivth-Bar {
    width: var(--main-wrapper-width);
    .card {
      .image-block {
        .category {
          font-size: 1.2em;
        }
      }
      .about {
        font-size: 1.2em;
        width: 100%;
        .time {
          font-size: 0.835em;
        }
        .category {
          font-size: 0.88em;
        }
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .fivth-Bar {
    .card {
      .about {
        .text {
          --snup: 1;
        }
      }
    }
  }
}
@media screen and (max-width: 998px) {
  .fivth-Bar {
    // margin: 2rem 0;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: none;
    grid-template-areas:
      "card-1 card-1 card-2"
      "card-3 card-4 card-2"
      "card-3 card-4 card-5"
      "card-6 card-7 card-5"
      "card-6 card-7 auto";
    grid-column-gap: 2em;
    grid-row-gap: 2em;
    .card {
      flex-direction: column;
      .image-block {
        max-width: inherit;
        flex: 0 0 30%;
        .image {
        }
        .category {
          display: block;
          font-size: 0.93em;
        }
      }
      .about {
        justify-content: inherit;
        text-align: start !important;
        padding: 2% 0 0 0;
        font-size: 1.15em;
        .category-about {
          display: none;
          height: inherit;
        }
        .decor-line-bottom {
          display: none;
        }
        .text {
          --snup: 4;
        }
        .time {
          padding: 4% 0 0 0;
          font-size: 0.792em;
        }
      }
      &:nth-child(1) {
        flex-direction: row;
        left: inherit;
        width: 100% !important;
        .image-block {
          min-width: 110px;
          max-width: 163px;
          .category {
            position: relative;
            font-size: 0.93em;
          }
          .image {
            height: auto;
            padding-bottom: 66%;
          }
        }
        .about {
          padding: 0 5% 0 2%;
          justify-content: space-between;
          .text {
            --snup: 3;
            font-size: inherit;
            margin-top: 1rem;
          }
          .time {
            padding: 3% 0 0 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 775px) {
  .card {
    .image-block {
      .category {
        text-transform: uppercase !important;
        font-weight: 600;
      }
    }
    .about {
      font-size: 1.15em;
    }
  }
}
@media screen and (max-width: 475px) {
  .fivth-Bar {
    margin: 1.5rem 0;
    // width: 100% !important;
    grid-template-columns: repeat(7, 1fr);
    grid-template-areas:
      "card-1 card-1 card-1 card-1 card-1 card-1  ."
      ". card-2 card-2 card-2 card-2 card-2 card-2"
      "card-3 card-3 card-3 card-3 card-3 card-3 ."
      ". card-4 card-4 card-4 card-4 card-4 card-4"
      "card-5 card-5 card-5 card-5 card-5 card-5 ."
      ". card-6 card-6 card-6 card-6 card-6 card-6"
      "card-7 card-7 card-7 card-7 card-7 card-7 .";
    grid-row-gap: 1.5em;
    grid-column-gap: 1.5em;
    .card {
      flex-direction: column !important;
      margin-bottom: 0 !important;
      .image-block {
        position: relative;
        .category {
          position: absolute !important;
          top: 0;
          left: 0;
          font-size: 0.72em !important;
        }
        .image {
          padding-bottom: 75%;
        }
      }
      .about {
        .time {
          padding-top: 4%;
          font-size: 0.69em;
        }
        .text {
          --snup: 2 !important;
          font-size: 12.6px !important;
        }
      }
      &:nth-child(1) {
        .image-block {
          max-width: inherit;
          min-width: inherit;
        }
      }
    }
  }
}
</style>
